import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHeader, Spinner, EmptyState } from "@/components/common";

export async function downloadExport(studyId, format) {
  try {
    const r = await api.get(`/admin/studies/${studyId}/export`, { params: { format }, responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `plena-ground-truth-${studyId.slice(0, 8)}.${format}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success(`${format.toUpperCase()} dışa aktarıldı`);
  } catch (e) { toast.error(errText(e)); }
}

export function ExportButtons({ studyId }) {
  return (
    <div className="flex gap-2">
      <Button variant="outline" data-testid={`export-json-${studyId}`} onClick={() => downloadExport(studyId, "json")} className="rounded-full"><Download className="mr-1.5 h-4 w-4" /> JSON</Button>
      <Button variant="outline" data-testid={`export-csv-${studyId}`} onClick={() => downloadExport(studyId, "csv")} className="rounded-full"><Download className="mr-1.5 h-4 w-4" /> CSV</Button>
    </div>
  );
}

export default function ExportsPage() {
  const [studies, setStudies] = useState(null);
  useEffect(() => { api.get("/admin/studies").then((r) => setStudies(r.data.filter((s) => s.status !== "DRAFT"))); }, []);
  if (!studies) return <Spinner />;
  return (
    <div className="fade-up">
      <PageHeader eyebrow="Dışa Aktar" title="Veri Dışa Aktar" description="Ham insan değerlendirme verisi; makine tarafından okunabilir JSON ve düzleştirilmiş CSV. Ortalama alınmaz, her uzman kararı ayrı kayıttır." />
      {!studies.length ? <EmptyState testId="exports-empty" title="Dışa aktarılacak değerlendirme yok" /> : (
        <div className="plena-card divide-y divide-plena-border">
          {studies.map((s) => (
            <div key={s.id} data-testid={`export-row-${s.id}`} className="flex flex-col gap-3 px-6 py-5 sm:flex-row sm:items-center sm:justify-between">
              <div><p className="font-heading font-semibold">{s.title}</p><p className="text-sm text-plena-text2">{s.candidate_count} aday · {s.criteria_count} kategori · {s.submitted_count} / {s.evaluator_count} tamamlandı · kategori seti v{s.rubric_version}</p></div>
              <ExportButtons studyId={s.id} />
            </div>
          ))}
        </div>
      )}
      <div className="mt-8 rounded-2xl bg-plena-surface2 px-6 py-5 text-sm text-plena-text2">
        <p className="font-medium text-plena-text">Kayıt yapısı</p>
        <p className="mt-1">Her kayıt: study_id · job (id, version) · rubric (version) · candidate (id, document_version) · evaluator · criteria[] (score 1–5, evidence_status, category_rank, category_tier, comment) · overall_score (0–100) · ranking.position · timestamps. CSV her satırda tek kategori puanı içerir.</p>
      </div>
    </div>
  );
}
